import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { GstTreatmentSelectComponent } from './gst-treatment-select.component';

@NgModule({
  declarations: [GstTreatmentSelectComponent],
  imports: [CommonModule, FormsModule, DropdownModule],
  exports: [GstTreatmentSelectComponent],
})
export class GstTreatmentSelectModule {}
